/* eslint-disable no-param-reassign */
import axios from "axios";

const customAxios = axios.create({
  baseURL: `${process.env.REACT_APP_YELLOW_DOOR_API}`,
  // baseURL: `http://192.0.0.165:3210/`,
});

const requestHandler = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    // eslint-disable-next-line dot-notation
    config.headers["access-token"] = token;
    return config;
  }
  return config;
};

const errorHandler = (error) => {
  console.log(error);
  if (error.response && error.response.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    // if (window.location.pathname !== `${process.env.REACT_APP_BASENAME}/auth`)
    //   window.location.pathname = `${process.env.REACT_APP_BASENAME}/auth`;
  }

  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (config) => requestHandler(config),
  (error) => errorHandler(error)
);
customAxios.interceptors.response.use(null, (error) => errorHandler(error));

export default customAxios;
